module.exports = __webpack_public_path__ + "img/faq-categories.un.c2a46f9.svg";